import {createSlice} from '@reduxjs/toolkit';
import menu from '../../models/menu.model';

interface menuInterface{
  menu:menu | undefined,
  loading:boolean,
  error:any,

  districtMenu:menu |undefined,
  loadingDM:boolean,

  quickLinks:menu |undefined,
  loadingQL:boolean,

  additionalLinks:menu |undefined,
  loadingAL:boolean,

  socialMedia:menu |undefined,
  loadingSocial:boolean,

}

const initialState:menuInterface = {
  menu:undefined,
  error:undefined,
  loading:false,

  districtMenu:undefined,
  loadingDM:false,

  quickLinks:undefined,
  loadingQL:false,

  additionalLinks:undefined,
  loadingAL:false,

  loadingSocial:false,
  socialMedia:undefined

}

const menuSlice = createSlice({
  name:'menu',
  initialState:initialState,
  reducers:{
    fetchtMenuRequest(state){
      state.loading = true;
    },

    fetchMenuSuccess(state,actions){
      state.loading = false;
      state.menu = actions.payload;
    },

    fetchMenuError(state,actions){
      state.loading = false;
      state.error = actions.payload;
    },


    fetchDMrequest(state){
      state.loadingDM = true;
    },

    fetchDMsuccess(state,actions){
      state.loadingDM = false;
      state.districtMenu = actions.payload
    },

    fetchDMfail(state,actions){
      state.loadingDM = false;
      state.error = actions.payload
    },

    // additional links

    fetchALrequest(state){
      state.loadingAL = true;
    },

    fetchALsuccess(state,actions){
      state.loadingAL = false;
      state.additionalLinks = actions.payload
    },

    fetchALfail(state,actions){
      state.loadingAL = false;
      state.error = actions.payload
    },

    // quick links
    fetchQLrequest(state){
      state.loadingQL = true;
    },

    fetchQLsuccess(state,actions){
      state.loadingQL = false;
      state.quickLinks = actions.payload
    },

    fetchQLfail(state,actions){
      state.loadingQL = false;
      state.error = actions.payload
    },

    //social
    // quick links
    fetchSocialRequest(state){
      state.loadingSocial = true;
    },

    fetchSocialsuccess(state,actions){
      state.loadingSocial = false;
      state.quickLinks = actions.payload
    },

    fetchSocialfail(state,actions){
      state.loadingSocial = false;
      state.error = actions.payload
    },
  }
});

export const {
  fetchtMenuRequest,
  fetchMenuError,
  fetchMenuSuccess,

  fetchDMfail,
  fetchDMrequest,
  fetchDMsuccess,

  fetchALfail,
  fetchALrequest,
  fetchALsuccess,

  fetchQLfail,
  fetchQLrequest,
  fetchQLsuccess,

  fetchSocialRequest,
  fetchSocialfail,
  fetchSocialsuccess

} = menuSlice.actions;

export default menuSlice.reducer;